import { CommonHelperFunctions } from "@kuika/kuika-cl-model";
import Axios, { AxiosResponse } from "axios";
import { KMainFunctions } from "../shared/utility/main-functions";

const backendUrl = CommonHelperFunctions.GetBackendUrl();

export interface IBuildDto {
  number: number;
  result: string;
  date: string;
  workspace: string;
  project: string;
  family?: string;
  deploymentChannel?: string;
}

export interface ICloudConsoleResponse {
  consoleOutput: string;
}

export interface ICloudFamily {
  value: string;
  label: string;
}

export interface IDeploymentRequest {
  project: string;
  configDir?: string;
  backendUrl?: string;
  frontendUrl?: string;
  wfeUrl?: string;
}

export interface IDeploymentResponse {
  success: boolean;
  message: string;
  family: string;
  workspace: string;
  jobUrl: string;
}

export class CloudService {
  public static GetIsCloudEnabled(): boolean {
    return false;
    // return (
    //   window.location.hostname === "localhost" ||
    //   window.location.hostname === "preprod.kuika.com" ||
    //   window.location.hostname === "platform.kuika.com"
    // );
  }

  /**
   * Get deployment builds for the current workspace and optional project
   */
  public static async GetBuilds(project?: string, limit?: number): Promise<AxiosResponse<IBuildDto[]>> {
    try {
      const params = new URLSearchParams();
      if (project) {
        params.append("project", project);
      }
      if (typeof limit === "number") {
        params.append("limit", String(limit));
      }
      const query = params.toString();
      const url = `${backendUrl}/cloud/builds${query ? `?${query}` : ""}`;
      return await Axios.get<IBuildDto[]>(url);
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return error;
    }
  }

  /**
   * Get distinct projects for the current workspace
   */
  public static async GetProjects(): Promise<AxiosResponse<string[]>> {
    try {
      return await Axios.get<string[]>(`${backendUrl}/cloud/projects`);
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return error;
    }
  }

  /**
   * Get console output for a specific build
   */
  public static async GetConsoleOutput(
    consoleType: string,
    buildNumber: number,
    project?: string,
    deploymentChannel?: string
  ): Promise<AxiosResponse<ICloudConsoleResponse>> {
    try {
      const url = new URL(`${backendUrl}/cloud/console/${encodeURIComponent(consoleType)}`);
      url.searchParams.append("buildNumber", String(buildNumber));

      if (project) {
        url.searchParams.append("project", encodeURIComponent(project));
      }

      if (deploymentChannel) {
        url.searchParams.append("deploymentChannel", encodeURIComponent(deploymentChannel));
      }

      return await Axios.get<ICloudConsoleResponse>(url.toString());
    } catch (error: any) {
      // KMainFunctions.exceptionHandler(error);
      return error;
    }
  }

  /**
   * Get available deployment families
   */
  public static async GetFamilies(): Promise<AxiosResponse<ICloudFamily[]>> {
    try {
      return await Axios.get<ICloudFamily[]>(`${backendUrl}/cloud/families`);
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return error;
    }
  }

  /**
   * Trigger a deployment build for the current workspace
   */
  public static async TriggerDeployment(request: IDeploymentRequest): Promise<AxiosResponse<IDeploymentResponse>> {
    try {
      return await Axios.post<IDeploymentResponse>(`${backendUrl}/cloud/deploy`, request);
    } catch (error: any) {
      KMainFunctions.exceptionHandler(error);
      return error;
    }
  }
}
